var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rtb-log-detail-adjustment__panel" },
    [
      _c(
        "div",
        {
          staticClass: "rtb-log-detail-adjustment__panel-heading",
          on: {
            click: function($event) {
              _vm.showAdjustment = !_vm.showAdjustment
            }
          }
        },
        [
          _c("i", {
            staticClass: "fa fa-angle-right",
            class: { "fa-rotate-90": _vm.showAdjustment },
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa p-r-5 p-l-5",
            class: _vm.adjustment.IsMatch ? "fa-check green" : "fa-close red",
            attrs: {
              title: _vm.$t(_vm.adjustment.IsMatch ? "MATCHED" : "NOT_MATCHED")
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "m-r-10" }, [
            _vm._v(_vm._s(_vm.adjustment.Setting.Criteria.TagId) + " "),
            _c("strong", [
              _vm._v(_vm._s(_vm.adjustment.Setting.Criteria.ComparisonType))
            ]),
            _vm._v(" " + _vm._s(_vm.adjustment.Setting.Criteria.Value))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "collapse",
        {
          model: {
            value: _vm.showAdjustment,
            callback: function($$v) {
              _vm.showAdjustment = $$v
            },
            expression: "showAdjustment"
          }
        },
        [
          _c("div", { staticClass: "rtb-log-detail-adjustment__panel-body" }, [
            _c("table", { staticClass: "table_basic" }, [
              _c("tbody", [
                _vm.adjustment.BidBefore
                  ? _c("tr", [
                      _c("th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "CELL_BID_BEFORE",
                            expression: "'CELL_BID_BEFORE'"
                          }
                        ],
                        attrs: { scope: "row" }
                      }),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.adjustment.BidBefore))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("tr", [
                  _c("th", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "CELL_ADJUSTMENT_TYPE",
                        expression: "'CELL_ADJUSTMENT_TYPE'"
                      }
                    ],
                    attrs: { scope: "row" }
                  }),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(_vm._s(_vm.adjustment.Setting.AdjustmentType))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "CELL_ADJUSTMENT_VALUE",
                        expression: "'CELL_ADJUSTMENT_VALUE'"
                      }
                    ],
                    attrs: { scope: "row" }
                  }),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(_vm._s(_vm.adjustment.Setting.AdjustmentValue))
                  ])
                ]),
                _vm._v(" "),
                _vm.adjustment.BidAfter
                  ? _c("tr", [
                      _c("th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "CELL_BID_AFTER",
                            expression: "'CELL_BID_AFTER'"
                          }
                        ],
                        attrs: { scope: "row" }
                      }),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.adjustment.BidAfter))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("tr", [
                  _c("th", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "CELL_MATCHED",
                        expression: "'CELL_MATCHED'"
                      }
                    ],
                    attrs: { scope: "row" }
                  }),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(_vm.$t(_vm.adjustment.IsMatch ? "YES" : "NO"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "CELL_REJECTED",
                        expression: "'CELL_REJECTED'"
                      }
                    ],
                    attrs: { scope: "row" }
                  }),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(_vm.$t(_vm.adjustment.Rejected ? "YES" : "NO"))
                    )
                  ])
                ])
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }